export default "/icons/jira.svg";